// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nuxt-progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 0.04831rem;\n  width: 0%;\n  opacity: 1;\n  -webkit-transition: width 0.1s, opacity 0.4s;\n  transition: width 0.1s, opacity 0.4s;\n  background-color: #fff;\n  z-index: 999999;\n}\n.nuxt-progress.nuxt-progress-notransition {\n  -webkit-transition: none;\n  transition: none;\n}\n.nuxt-progress-failed {\n  background-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
